import axios from '@/api/axios';
import type {AfriexFeeType} from '@/types';

export const feeService = {
  getTransactionFees: async (): Promise<AfriexFeeType> => {
    const url = `/v2/admin/transactions/fees`;
    const response = await axios.get<AfriexFeeType>(url);
    return response?.data;
  },
  updateTransactionFees: async (fee: AfriexFeeType): Promise<AfriexFeeType> => {
    const url = `/v2/admin/transactions/fees`;
    const response = await axios.post<AfriexFeeType>(url, fee);
    return response?.data;
  },
};
